export default "__VITE_ASSET__Bz9nCHGh__"